angular.module("persons")

    .controller("AttendedEventsModalCtrl", ['$state', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'person_id', '$http', 'treeService', '$uibModal', 'gridService', '$q', '$interval', '$timeout', 'uiGridConstants', 'datasetsService', function ($state, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, person_id, $http, treeService, $uibModal, gridService, $q, $interval, $timeout, uiGridConstants, datasetsService) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.export = function(){
        var options = {
            filters: {
                EXPORT_TYPE: "LOCATION",
                PERSON_ID: person_id
            }
        };

        datasetsService.exportByType("persons", options);
    }

    $scope.goToEvent = function (rowEntity) {
        $scope.onCancel();
        $state.go("events.edit.guests", { id: rowEntity.FK_events_guests_events.id });
    };

    /* GRIDS */
    $scope.gridAttendedEvents = {
        pdfTitle: $filter('translate')('persons.attended_events'),
        exporterCsvFilename: $filter('translate')('persons.attended_events') + ".csv",
            exporterExcelFilename: $filter('translate')('persons.attended_events') + ".xlsx",
            // Formateamos csv 
        exporterCsvColumnSeparator: ';',                // Formateamos csv 
        exporterMenuCsv: true,
        enableGridMenu: true,
        gridMenuShowHideColumns: false,
        paginationPageSizes: [10, 20, 30],
        paginationPageSize: 10,
        onRegisterApi: function (gridApi) {
            this.gridApi = gridApi;
        },
        columnDefs: [
            { name: 'id', visible: false, exporterSuppressExport: true },
            {
                name: 'event_name', field: 'FK_events_guests_events.name', displayName: $filter('translate')('persons.event_name'), enableColumnMenu: false, enableFiltering: true, enableHiding: false,
                cellTemplate: '<div class=\"ui-grid-cell-contents\"><a class=\"aColorBlack\" ng-click=\"grid.appScope.goToEvent(row.entity)\">{{row.entity.FK_events_guests_events.name}}</a></div>'
            },
            {
                name: 'date', field: 'FK_events_guests_events.date_from', displayName: $filter('translate')('persons.date'),
                type: 'date', enableColumnMenu: false, enableFiltering: false, width: 100,
                cellTemplate: '<div class=\"ui-grid-cell-contents\">{{row.entity.FK_events_guests_events.date_from | toLocalDate | date:"dd/MM/yyyy"}}</div>',
                customFormatFn: function (value) {
                    if (value != null) {
                        var fecha = new Date(value);
                        return $filter('date')(fecha, 'dd/MM/yyyy');
                    }
                    return "";
                },
            },
            {
                name: 'confirmation_status', displayName: $filter('translate')('events.guests.status'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,width: 100,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'pending\'"><span style="display:block; height: 19px;" class="label label-warning">{{\'events.guests.pending\' | translate}}<span></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'confirmed\'"><span style="display:block; height: 19px;" class="label label-primary">{{\'events.guests.confirmed\' | translate}}<span></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'delegated\'"><span style="display:block; height: 19px;" class="label label-information">{{\'events.guests.delegated\' | translate}}<span></div>' +
                    '<div class="ui-grid-cell-contents" ng-if="row.entity.confirmation_status === \'rejected\'"><span style="display:block; height: 19px;" class="label label-danger">{{\'events.guests.rejected\' | translate}}<span></div>',
                customFormatFn: function (value) {
                    if (value != null) {
                        return $filter('translate')('events.guests.'+value);
                    }
                    return "";
                },
            }
        ],
        getData: function (options) {
            options.person_id = person_id;
            return Restangular.all('Persons/AttendedEvents').getList(options);
        }
    };


}])
;